import { uv, fract, min, mix, step, smoothstep, color } from 'three/tsl'
import AgxPhysicalMaterial from './AgxPhysicalMaterial'

export default class WireMaterial extends AgxPhysicalMaterial {
	static defaults = {
		tint: 0xb23a48,
		shadow: 0x101010,
		around: 8,
		along: 4,
		roughness: 0.5,
		metalness: 0,
	}

	constructor(options = {}) {
		const { tint, shadow, around, along, ...rest } = { ...WireMaterial.defaults, ...options }

		super(rest)

		const coord = uv()
		const warp = fract(coord.x.mul(around).add(coord.y.mul(along)))
			.sub(0.5)
			.abs()
			.mul(2)
		const weft = fract(coord.x.mul(around).sub(coord.y.mul(along)))
			.sub(0.5)
			.abs()
			.mul(2)
		const strand = smoothstep(0.2, 1, min(warp, weft)).oneMinus()

		this.colorNode = mix(color(shadow), color(tint), step(warp, weft)).mul(strand.mul(0.7).add(0.3))
		this.roughnessNode = strand.oneMinus().mul(0.2).add(rest.roughness)
	}
}
